import React from "react";
import s from "./style.module.css";
import Container from "../Container";

const Columns = ({ children }) => {
  return <Container className={s.container}>{children}</Container>;
};

export default Columns;
